import { render, staticRenderFns } from "./modal-merge-cart-superuser.vue?vue&type=template&id=4370f34b&scoped=true&"
import script from "./modal-merge-cart-superuser.vue?vue&type=script&lang=js&"
export * from "./modal-merge-cart-superuser.vue?vue&type=script&lang=js&"
import style0 from "./modal-merge-cart-superuser.vue?vue&type=style&index=0&id=4370f34b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370f34b",
  null
  
)

export default component.exports